<template>
  <div class="exhorList">
    <ul v-if="tableData.list.length">
      <li class="exhItem" v-for="(item,i) in tableData.list" :key="i" @click="exhjump(item)">
        <div class="exhItemLeft">
          <div class="exhItemImg" >
            <img :src="item.corplogo_cn" alt=""/>
          </div>
          <div class="exhDetails">
            <h2 v-if="item.corpname_en" >{{item.corpname_en}}</h2>
            <h2 v-else >{{ item.corpname_cn }}</h2>
            <div class="listLeft">
              <p>
                <span class="title">Website：</span>
                <span class="content">{{item.website}}</span>
              </p>
              <p>
                <span class="title">Add：</span>
                <span class="content">{{item.address_en}}</span>
              </p>
            </div>
            <div class="listRight">
              <p>
                <span class="title">Booth No：</span>
                <span class="content">{{item.booth}}</span>
              </p>
              <p>
                <span class="title">Booth Area：</span>
                <span class="content">{{item.area}}m²</span>
              </p>
            </div>
          </div>
        </div>
        <div class="exhItemBtn">
          <button class="marginbottom" v-if="item.coll==1" @click.stop="collection(item)">
            <img :src="hrefurl+'/public/icon/enshrine_1.png'" alt=""/>
            Favorites
          </button>
          <div class="marginbottom" v-else @click.stop>
            <el-popconfirm title="Are you sure to cancel?" confirm-button-text="Confirm" cancel-button-text="Cancel" @onConfirm='collection(item)' >
              <el-button class="btnActive" type="danger" slot="reference">
                <img :src="hrefurl+'/public/icon/enshrine_1.png'" alt=""/>
                My Favorites
              </el-button>
            </el-popconfirm>
          </div>
          <button @click.stop="make(item)" :class="item.corp_app==1?'':'btnActive'">
            <img :src="hrefurl+'/public/icon/pack_1.png'" alt=""/>
            {{item.corp_app==1?'Contact ':'Contacted'}}
          </button>
          
        </div>
      </li>
    </ul>
     <div class="loadingNull" v-else>
      <div class="loading" v-if="tableData.loading">
        <div>
          <img :src="hrefurl+'/public/icon/loading.gif'" alt=""/>
        </div>
      </div>
      <div class="null" v-else>
        <div>
          <img :src="hrefurl+'/public/icon/without.png'" alt=""/>
        </div>
         No data is available!
      </div>
    </div>
    <el-pagination
      v-if="tableData.listnum>20"
      :key="page_key"
      @current-change="handleCurrentChange"
      :current-page.sync="tableData.thispage"
      :page-size="20"
      layout="total, prev, pager, next "
      :pager-count="5"
      prev-text="prev"
      next-text="next"
      :total="tableData.listnum * 1"
    >
    </el-pagination>
    <!-- 约见弹窗 start -->
    <el-dialog class="yuyue" title="Make an Appointment" :visible.sync="dialogFormVisible" :before-close="resetForm" width="650px" top="3vh" center>
      <el-form ref="preAboutData" :model="preAboutData" :rules="rules" size="mini">
        <el-form-item label="Appointment Date" prop="date">
          <el-date-picker type="date" placeholder="Select Date" :picker-options='pickerOptions' v-model="preAboutData.date" style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item label="Leave a Message" prop="connet">
          <el-input type="textarea" maxlength="150" show-word-limit placeholder="Input Your Message" v-model="preAboutData.connet"></el-input>
        </el-form-item>
        <el-form-item size="large" style="text-align: center;">
          <el-button type="primary" @click="submitForm('preAboutData')">Request A Meeting</el-button>
          <el-button @click="resetForm">Cancel</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 约见弹窗 end -->
  </div>
</template>

<script>
import { reqCorpCollDo, reqCorpAppDo } from "../../api";
export default {
  props:["tableData","page_key"],
  data(){
    return{
      collect:false,
      meet:1,
      item:{},
      dialogFormVisible:false,//预约弹窗
      rules:{//正则校验
        date:[{ type: 'date', required: true, message: 'Select Date', trigger: 'change' }],
        connet:[{required: true, message: 'Input Your Message', trigger: 'blur'}],
      },
      preAboutData:{
        id:0,
        date:"",
        connet:"",
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;//如果没有后面的-8.64e7就是不可以选择今天的
        }
      }
    }
  },
  methods:{
     submitForm(formName) {//预约表单
      this.$refs[formName].validate(async(valid) => {
        if (valid) {//发送
          console.log(this.preAboutData);
          this.preAboutData.id=this.item.ocid
          const response = await reqCorpAppDo(this.preAboutData)
          if (response.code==0) {
            this.meet=response.is_coll
            this.success(this,'Succeed')
            this.$emit("make",this.item.ocid,response.is_coll)
            this.$refs.preAboutData.resetFields();
            this.dialogFormVisible=false
          }else{
            this.err(this,'Timeout, please try...')
          }
        } else {//错误
          return false;
        }
      });
    },

    resetForm() {//预约表单重置
      this.$refs.preAboutData.resetFields();
      this.dialogFormVisible=false
    },

    exhjump(item){// 跳转
      if (this.jump(this)) {
        this.$router.push('/exhibitor/details/'+item.id+"/"+item.ocid)
      }
    },

    handleCurrentChange(val,a) {
      console.log(val,a);
      this.$emit("amend",val)
    },

    async collection(item){//收藏
      if (!this.jump(this)) return
      const response = await reqCorpCollDo(item.ocid)
      let collect=0
      if (response.code==0) {
        collect=response.is_coll
      }else{
        collect = item.coll
      }
      this.$emit("collect",item.ocid,collect)
    },

    async make(item){ //约见
      if (!this.jump(this)) return
      console.log(item.corp_app);
      if (!(item.corp_app*1==1)) return//已预约返回
      this.item=item
      this.dialogFormVisible=true
    }
  }
};
</script>

<style scoped>
  /* 列表 21-1-28版 start*/
    .exhorList>ul{
      width: 100%;
    }
    .exhItem{
      border: 1px solid transparent;
      border-top: 1px solid #e6e6e6;
      padding: 20px 10px;
      background-color: white;
      display: flex;
      justify-content:space-between;
      cursor: pointer;
      box-sizing: border-box;
      margin-bottom: 10px;
    }
    .exhItem:hover{
      position: relative;
      box-shadow:3px 3px 8px 0 rgba(0,0,0,.1);
      border: 1px solid #e6e6e6;
      z-index: 1;
    }
    .exhItem:first-child{
      border-top: none;
    }
    .exhItemLeft{
      display: flex;
      width: calc(100% - 100px);
    }
    .exhItemImg{
      width: 120px;
      height: 120px;
      margin-right: 30px;
      border: 1px solid #aaa;
      border-radius: 6px;
      overflow: hidden;
      cursor: pointer;
    }
    .exhDetails{
      line-height: 26px;
      width: calc(100% - 150px);
    }
    .exhDetails h2{
      color: #333;
      line-height: 32px;
      cursor: pointer;
      font-weight: 600;
      padding-bottom: 10px;
      width: 90%;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      vertical-align: middle;
      font-family: 'FjallaOne-Regular';
      font-size: 17px;
    }
    .exhDetails h2:hover{
      /* color: #f08300; */
      color: #008baf;
    }
    
    .exhDetails .listLeft{
      display: inline-block;
      width: 66%;
    }
    .listLeft .title{
      display: inline-block;
    }
    .listLeft .content{
      width: calc(100% - 92px);
      /* width: 80px; */
      height: auto;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      vertical-align: middle;
    }
    .exhDetails .listRight{
      display: inline-block;
      width: 30%;
    }
    .listRight .title{
      display: inline-block;
      vertical-align: middle;
    }
    .listRight .content{
      display: inline-block;
      vertical-align: middle;
      height: auto;
      width: auto;
    }
    .exhDetails p{
      /* color: #747474; */
      color: #666666;
      font-size: 14px;
      line-height: 32px;
    }
    .exhItemBtn{
      display: flex;
      flex-direction: column;
      justify-content: left;
      padding-top: 40px;
      /* align-items: center; */
    }
    .exhItemBtn button{
      width: 100px;
      line-height: 30px;
      cursor: pointer;
      color: white;
      background-color: #008baf;
      border: 1px solid#008baf;
      border-radius: 4px;
      transition: all .5s;
      outline: none;
      padding: 0;
      font-family: 'FjallaOne-Regular';
    }
    .marginbottom{
      margin-bottom: 14px;
    }
    
    .exhItemBtn button:hover{
      background-color: #67c3d3;
      border-color: #67c3d3;
    }
    .exhItem .exhItemBtn .btnActive{
      background-color: #f08300;
      border-color: #f08300;
    }
    .exhItemBtn button img{
      width: 18px;
    }
  /* 列表 21-1-28版 end*/

  .exhorList>>>.el-pagination{
    padding: 30px 0;
    margin: 0 auto;
    display: flex;
    justify-content: center;
  }
  .exhorList>>>.el-dialog,
  .exhorList>>>.el-pager li,
  .exhorList>>>.el-pagination,
  .exhorList>>>.el-pagination .btn-next,
  .exhorList>>>.el-pagination .btn-prev,
  .exhorList>>>.el-pagination button:disabled{
    background: none;
  }
  .exhorList>>>.el-input__icon{
    line-height: 1;
  }
  .exhorList>>>.el-table{
    color: #333;
  }
  .exhorList>>>.el-table th{
    text-align: center;
  }

  /* 加载无数据显示 */
  .loadingNull{
    width: 400px;
    text-align: center;
    margin: 140px auto;
    height: 100%;
  }
  .loading>div{
    width: 80px;
    margin: 180px auto;
  }
  .null>div{
    
    width: 200px;
    margin: 20px auto;
  }
</style>
<style scoped>
/* 预约弹窗 */
.yuyue>>> .el-dialog{
  background-color: white;
}
.yuyue >>> .el-dialog__body{
  padding: 20px 80px 20px 60px;
}
.yuyue >>>.el-form-item--mini.el-form-item,
.yuyue >>>.el-form-item--small.el-form-item{
  margin-bottom: 24px;
}
.yuyue >>>.el-form-item__label{
  line-height: 40px;
}
.yuyue >>> .el-input{
  width: 100%;
}
.yuyue >>>.el-input .el-input__inner{
  line-height: 40px;
  height: 40px;
}
.yuyue>>>.el-col-2{
  text-align: center;
  line-height: 40px;
}

.yuyue >>> .el-textarea__inner{
  width: 100%;
  padding: 10px;
  border-radius: 4px;
  font-size: 14px;
  height: 140px;
}
.yuyue >>> .el-textarea__inner:focus,
.yuyue>>>.el-input__inner:focus{
  border-color: #008baf;
}
.yuyue >>> .el-button{
  min-width: 150px;
}

</style>